import { type DeepPartial } from '@direct-frontend/stdlib';
import { type PromoactionModel } from './types';

export const getPromoactionUsageCountText = (promoaction: DeepPartial<PromoactionModel>): string => {
    if (promoaction.validity?.isOneTimeUse === 'true') {
        return 'Ограничить: 1 раз';
    }

    return 'Без ограничений';
};
